// extracted by mini-css-extract-plugin
export default {"subTitle":"render-table-cell_subTitle__J6YOn","placeHolderShimmer":"render-table-cell_placeHolderShimmer__rMGgs"};